import {isEmpty} from "../../../../_helpers/commonFunctions";

export const formatMasterAIStatus = (aiStatus) => {
    if (aiStatus === -1) {
        return "Ο τύπος αρχείου δεν υποστηρίζεται από το AI";
    } else if (aiStatus === -3) {
        return "Εσφαλμένη απάντηση από το Primer AI";
    } else if (aiStatus === -4) {
        return "Σφάλμα κατά την ταξινόμηση";
    } else if (aiStatus === -5) {
        return "Αδυναμία ταξινόμησης λόγω αβεβαιότητας περιεχομένου";
    } else if (aiStatus === -6) {
        return "Λανθασμένη χρονιά αρχείου";
    } else if (aiStatus === -7) {
        return "Τα AI credits δεν επαρκούν";
    } else if ([1001].includes(aiStatus)) {
        return "Καταχωρημένο με την βοήθεια του Primer AI";
    }
    return "Αναμονή ανάλυσης από Primer AI";
}

export const formatMasterAIStatusColor = (aiStatus) => {
    if (aiStatus === -1) {
        return "ai-status-user-action";
    } else if ([-3, -4, -5, -6, -7].includes(aiStatus)) {
        return "ai-status-error";
    } else if ([1001].includes(aiStatus)) {
        return "ai-status-success";
    }
    return "ai-status-process";
}

export const formatMasterAIStatusColorCloud = (aiStatus) => {
    if (aiStatus === -1) {
        return "lightgray";
    } else if ([-3, -4, -5, -6, -7].includes(aiStatus)) {
        return "lightcoral";
    }
    return "#8dc6ff";
}

export const formatAIDocumentColorCloud = (erp_status) => {
    if (isEmpty(erp_status) || [0, 125, 200, -200, 201, 499, 500].includes(erp_status)) {
        return "#8dc6ff";
    } else if ([-121, -122, -123].includes(erp_status)) {
        return "#ff7e67";
    } else if ([1000, 1001].includes(erp_status)) {
        return "#42b883";
    } else if ([-501, -1].includes(erp_status)) {
        return "#afaeae";
    }
}

export const formatAIDocumentStatus = (erp_status, isFromMyData = false, isFromPayroll = false, isBatchSettlement = false) => {
    if (isEmpty(erp_status) || erp_status === 0) {
        return "Αναμονή επεξεργασίας από Primer AI";
    } else if ([1000].includes(erp_status)) {
        return "Καταχωρημένο από Primer AI";
    } else if ([1001].includes(erp_status)) {
        return "Καταχωρημένο με την βοήθεια του Primer AI";
    } else if ([499, 500].includes(erp_status)) {
        return "Ολοκλήρωση επεξεργασίας από Primer AI και αναμονή ενεργειών χρήστη";
    } else if ([-121, -123].includes(erp_status)) {
        if (isFromMyData) return "Αδυναμία Επεξεργασίας Παραστατικού!";
        if (isFromPayroll) return "Αδυναμία Επεξεργασίας Μισθοδοσίας!";
        if (isBatchSettlement) return "Αδυναμία Επεξεργασίας πακέτου συναλλαγών!";
        return "Αδυναμία Επεξεργασίας Αρχείου!";
    } else if (erp_status === -122) {
        return "Το παραστατικό θα έπρεπε να έχει διαβιβαστεί στο myDATA";
    } else if (erp_status === 125) {
        return "Επιτυχής έλεγχος";
    } else if (erp_status === -501) {
        return "Απόρριψη από χρήστη";
    } else if (erp_status === -1) {
        return "Αναμονή επαναεπεξεργασίας";
    } else if ([200, -200, 201].includes(erp_status)) {
        if (isFromPayroll) return "Αναμονή Primer AI για επεξεργασία δεδομένων μισθοδοσίας";
        if (isBatchSettlement) return "Αναμονή Primer AI για επεξεργασία δεδομένων συναλλαγών";
        return "Αναμονή Primer AI για χαρακτηρισμό γραμμών παραστατικού";
    }
}

export const formatAIDocumentColor = (erp_status) => {
    if (isEmpty(erp_status) || [0, 125, 200, -200, 201, 499, 500].includes(erp_status)) {
        return "ai-status-process";
    } else if ([-121, -122, -123].includes(erp_status)) {
        return "ai-status-error";
    } else if ([1000, 1001].includes(erp_status)) {
        return "ai-status-success";
    } else if ([-501, -1].includes(erp_status)) {
        return "ai-status-user-action";
    }
}

export const aiModuleTemplateTypes = [
    {value: "files", label: "Αρχεία"},
    {value: "myDataClearance", label: "myDATA"},
]

export const vatDeductibleToleranceLabels = [
    { value: 1, label: "Πολύ υψηλό" },
    { value: 2, label: "Υψηλό" },
    { value: 3, label: "Ισορροπημένο" },
    { value: 4, label: "Χαμηλό" },
    { value: 5, label: "Πολύ χαμηλό" },
]
